/* global define:true, fpti:true, PAYPAL:true */
/* eslint no-undefined:0 */

/**
 * @fileOverview Analytics – link and error tracking
 * @name Analytics Widget
 * @author dquock
 */
define([
	'jquery',
	'backbone',
	'BaseView',
	'components/consumerweb-client-error-logger/error'
], function ($, Backbone, BaseView, Error) {

	'use strict';

	var View = BaseView.extend({

			el: 'body',

			events: {
			// track a link with data-pagename
				'click [data-pagename]': 'trackLink'
			},

			previousPage: null,

			initialize: function () {
			// used to track an input button when successfully submitting forms
				this.listenTo(Backbone, 'trackLink', this.trackLink);

			// used to track a link on the same page
				this.listenTo(Backbone, 'trackLinkName', this.trackLinkName);

			// used to track an error
				this.listenTo(Backbone, 'trackError', this.trackError);

			// used to track goals
				this.listenTo(Backbone, 'trackGoal', this.trackGoal);

			// used to track overpanel impressions
				this.listenTo(Backbone, 'trackOverpanelImpression', this.trackOverpanelImpression);

			// Used to track page impression
				this.listenTo(Backbone, 'trackImpression', this.trackImpression);

			// Used to track alert dialog as impression
				this.listenTo(Backbone, 'trackAlertDialog', this.trackAlertDialog);

			// Used to track previous page impression. Ex: Dismiss alert dialog
				this.listenTo(Backbone, 'trackPreviousPageImpression', this.trackPreviousPageImpression);
			},

		/**
		 * Set FPTI/SC variables and fire tracking beacons
		 * @param prop Prop value to record
		 * @param isLink whether to record it as an link click or a page transition
		 */
			fireBeacon: function(prop, isLink) {
				this.analytics.options.request.url = PAYPAL.analytics.instance.options.request.url;
				try {
					if (isLink) {
					// fpti beacon
						this.analytics.recordClick();
					} else {
					// fpti beacon
						fpti.link = null;
						fpti.pglk = null;
						fpti.pgln = null;
						this.analytics.recordImpression();
					}
				} catch (err) {
					Error.log('/myaccount/error', 'analytics error');
				}
			},

		/**
		 * Set FPTI/SC variables and fire tracking beacons
		 * @param linkName
		 * @param pageName
		 * @param pageName2
		 * @param trackType
		 * @param transactionDetailsLinks
		 * @param goal
		 * @param isImpression - flag to determine if page should be tracked as an impression, skips link, pglk, pgln
		 */
			track: function (linkName, pageName, pageName2, trackType, transactionDetailsLinks, goal, isImpression) {
				isImpression = isImpression || false;
				var pageNameBasedOnUrl = this.getPageNameBasedOnUrl();
			// set linkname
				if (!isImpression) {
					fpti.link = linkName;
				} else if (pageNameBasedOnUrl !== pageName) {
					this.previousPage = pageNameBasedOnUrl;
				}

			// set pageNames
				fpti.page = pageName2;
				// TODO: determine if moving `pgrp` before `pglk` causes tracking issues for others
				// it was below and so `pglk` was always one pageName behind, since it was using the cached value
				fpti.pgrp = pageName;

				if (!isImpression) {
					fpti.pglk = pageName + '|' + fpti.link;
					fpti.pgln = pageName2 + '|' + fpti.link;
				}

			// set goal
			// null - avoids issue with carrying this value over as fpti is a global object.
				fpti.goal = goal ? goal : null;

			// clear out error props, in case they exist
				fpti.erpg = undefined; // error message
				fpti.erfd = undefined; // form field with error (field1|field2|field3)
				fpti.eccd = undefined; // error code
				fpti.comp = 'walletexpnodeweb';

			// fire link or impression
				switch (trackType) {
					case 'link':
						this.fireBeacon(fpti.link, true);
						break;
					default:
						this.fireBeacon();
						break;
				}

			// set attrs for automation
				$('#analytics').attr('data-pagename', pageName)
				.attr('data-c25', pageName2)
				.attr('data-c27', fpti.pglk);

			// clear custom variables
				this.clearCustomVariables();
			},

		/**
		 * Link tracking : Tracks clicks on the links
		 * @param event - click event || the clicked jQuery object of the input used to submit a form
		 * if event isn't defined or is null, explicitly specify params
		 * @param linkName name attribute
		 * @param pageName data-pagename the link is going to
		 * @param pageName2 data-pagename2 the link is going to
		 * @param trackType page-level or not
		 * @param transactionDetailsLinks activity transaction details links
		 * @param goal - goal of the event (e.g. - "addBankSuccess" when success handler is triggered)
		 * @param isImpression - flag used to determine if page should be tracked as an impression
		 */
			trackLink: function (event, linkName, pageName, pageName2, trackType, transactionDetailsLinks, goal, isImpression) {
				var target,
					$link;

				if (fpti) {
					target = event && event.currentTarget;
					$link = target ? $(target) : event;
					if ($link && $link.data) {
						linkName = $link.attr('name') || $link && $link.html();
						pageName = $link.data('pagename') || fpti.pgrp;
						pageName2 = $link.data('pagename2');
						trackType = $link.data('track-type');
						transactionDetailsLinks = $link.data('transactiondetailslinks');
						if ($link.data('crdtp')) {
							fpti.crdtp = $link.data('crdtp');
						}
						if ($link.data('crcd')) {
							fpti.crcd = $link.data('crcd');
						}
						// Maps all anchors and buttons to be tracked as a link
						if ($link.prop('tagName') === 'A' || $link.prop('tagName') === 'INPUT' || $link.prop('tagName') === 'BUTTON' || $link.prop('tagName') === 'LABEL') {
							trackType = 'link';

							// Restricting this change to wallet only for now...
							var pageUrl = window.location.href;
							if (pageUrl && pageUrl.search('wallet') !== -1) {
								// This will make sure all the click events are tracked on the same page..
								pageName = fpti.pgrp;
								pageName2 = null;
							}
						}
					} else if (!pageName) {
						pageName = this.getPageNameBasedOnUrl(); // Get this based on the page url ...
					}


					this.track(linkName, pageName, pageName2 || pageName + ':::', trackType, transactionDetailsLinks, goal, isImpression);
					fpti.crdtp = undefined;
					fpti.crcd = undefined;
				}
			},

		/**
		 *	Tracks link on a page
		 *	keeps the pagenames the same, but tracks the link
		 *	@param linkName linkName to track
		 *  Will be deprecated soon. Don't use this for new ones. Instead use trackAsImpression
		 */
			trackLinkName: function (linkName) {
				if (fpti) {
				// set linkname
					fpti.link = linkName;
					fpti.pglk = fpti.pgrp + '|' + fpti.link;
					fpti.pgln = fpti.pgrp + ':::|' + fpti.link;

				// clear out error props, in case they exist
					fpti.erpg = undefined; // error message
					fpti.erfd = undefined; // form field with error (field1|field2|field3)
					fpti.eccd = undefined; // error code

					this.fireBeacon(fpti.link, false);

				// clear custom variables
					this.clearCustomVariables();

				// set attr for automation
					$('#analytics').attr('data-c27', fpti.pglk);
				}
			},

		/**
		 *	Tracks errors
		 *	@param error The object containing the props to set
		 */
			trackError: function (error) {
				if (fpti) {
				// set error props
					fpti.erpg = error.message; // error message
					fpti.erfd = error.fieldId; // form field with error (field1|field2|field3)
					fpti.eccd = error.code; // error code

					this.fireBeacon();

				// clear custom variables
					this.clearCustomVariables();

				// set attrs for automation
					$('#analytics').attr('data-pagename', fpti.pgrp)
					.attr('data-c25', fpti.page)
					.attr('data-c27', fpti.pglk);
				}
			},

		/**
		 * Tracks goals, which are events that aren't "clicks" or "impressions", but something else that occurred that
		 * you want to track (e.g. a success handler gets triggered)
		 * @param goal
		 * @param pageName
		 */
			trackGoal: function (goal, pageName) {
				var self = this;

				setTimeout(function () {
					pageName = pageName || self.getPageNameBasedOnUrl();
					fpti.pgrp = pageName || fpti.pgrp;
					self.trackLink(null, goal, pageName || fpti.pgrp, null, null, null, goal);
				}, 0);

			},

		/**
		 *	Tracks impression of a page. Sets link, pglk, pgln to null
		 *	@param pageName
		 *	@param pageName2
		 *	@param fptiCustomTags
		 *	Sends the isImpression flag as true
		 **/
			trackImpression: function (pageName, pageName2, fptiCustomTags) {
				pageName = pageName || this.getPageNameBasedOnUrl();

				if (!pageName2) {
					pageName2 = pageName + ':::';
				}

				if (fptiCustomTags) {
					for (var key in fptiCustomTags) {
						if (fptiCustomTags.hasOwnProperty(key)) {
							fpti[key] = fptiCustomTags[key];
						}
					}
				}

				if (fpti) {
					fpti.link = null;
					fpti.pglk = null;
					fpti.pgln = null;
				}

				this.trackLink(null, null, pageName, pageName2, null, null, null, true);
			},

		/**
		 * Tracks Overpanel Impressions, which are events "impressions"
		 * @param overpanelPageName
		 */
			trackOverpanelImpression: function (overpanelPageName) {
				var pageName;

				if (overpanelPageName && overpanelPageName.search('wallet/overpanel/') !== -1) {
					overpanelPageName = overpanelPageName.replace(/\//g, ':');
					pageName = overpanelPageName.replace(/wallet:overpanel:/g, 'main:walletweb:wallet::');
					pageName = pageName.toLocaleLowerCase();

					this.trackImpression(pageName);
				}
			},

		/**
		 *	Tracks alert dialog as impression dynamically on the page it's shown
		 */
			trackAlertDialog: function (alertName) {
				// Limiting the page elements after '::' as it should be only two. So, we need to replace them
				var pageName = 'main:walletweb::alertdialog:' + alertName;
				this.trackImpression(pageName);
			},

		/**
		 *	Tracks previous page as impression dynamically on the page it's shown
		 *	Ex: when alert dialog is dismissed, current overpanel will be tracked for impression
		 */
			trackPreviousPageImpression: function (pageName) {
				if (pageName) {
					this.trackImpression(pageName);
				} else if (this.previousPage) {
					this.trackImpression(this.previousPage);
				}
			},

		/**
		 *	Set the page name based on the url.
		 * 	Mostly used when overpanel is closed and the page impression has to be tracked
		 */
			getPageNameBasedOnUrl: function (url) {
				var pageName = fpti && fpti.pgrp;
				url = url || window.location.href; // replacement for old site catalyst var s.getPageUrl()
				if (url) {
					pageName = url.replace(/(.*)?myaccount\//g, 'main:walletweb:').replace(/\?.*/, ''); // removes params Ex: ?flow=abc

					if (pageName === 'main:walletweb:home') {
						pageName = 'main:walletweb:summary::home';
					} else if (pageName.search('/') === -1) { // If it's the root of home page, then add ':home'
						pageName += '::home';
					} else { // If it's not the root of the page, then replace '/' with ':'
						// Replace BA-alphanumeric or CC-alphanumeric (i.e remove cards & bank id's)
						// Ex: /wallet/card/CC-UCY68ZQHC74NU => /wallet/card
						pageName = pageName.replace(/\/[A-Z0-9\-]+(?=\/|$)/g, '').replace(/\//g, ':');
					}
				}

				return pageName;
			},

		/**
		 *	Clears the custom variables which are set on the fpti object
		 */
			clearCustomVariables: function () {
				fpti.mbwt = undefined;
				fpti.mbgp = undefined;
			}
		}),

		Analytics = {
			view: null, // to be instantiated in initialize

		/**
		 *	Initialize Analytics
		 */
			initialize: function () {
				var prevPage = fpti && fpti.pglk || '';

			// instantiate the view
				this.view = new View();

			// instantiate analytics for FPTI
				this.view.analytics = new PAYPAL.analytics.Analytics();

			// initialize prop27 = previous pagename|linkname
				$('#analytics').attr('data-c27', prevPage);

			// can access FPTI performance info from PAYPAL.analytics.perf
			// https://dev.paypal.com/wiki/General/FPTI-PerformanceTracking
			}
		};

	return Analytics;
});



//////////////////
// WEBPACK FOOTER
// ./widgets/analytics.js
// module id = 868
// module chunks = 0